import { useEffect } from 'react';
import { ProductSuite } from '@parrot/product-suite';
import styles from './product-suite-drawer.module.css';

export interface ProductSuiteDrawerProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Full-screen overlay that renders the @parrot/product-suite component.
 * Matches the pattern used by PlexieDrawer — backdrop click + Escape to close.
 */
export function ProductSuiteDrawer({ open, onClose }: ProductSuiteDrawerProps) {
  // Close on Escape
  useEffect(() => {
    if (!open) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <>
      <div className={styles.backdrop} onClick={onClose} aria-hidden="true" />
      <div className={styles.overlay} role="dialog" aria-label="Product Suite" aria-modal="true">
        <button
          className={styles.closeBtn}
          onClick={onClose}
          aria-label="Close Product Suite"
          type="button"
        >
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
            <path d="M2 2l14 14M16 2L2 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>
        <ProductSuite theme="dark" />
      </div>
    </>
  );
}
